import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormGroup, FormControlLabel, Switch, Grid } from '@material-ui/core'

const SelectorDeCarga = ({ esCargaMasiva, onChange }) => {
  return (
    <Grid container justify='center' direction='column' alignItems='center' spacing={3}>
      <Grid item>
        <FormControl fullWidth component='fieldset'>
          <FormGroup aria-label='carga masiva' row>
            <FormControlLabel
              style={{ margin: 'auto' }}
              value='start'
              control={
                <Switch
                  color='primary'
                  checked={esCargaMasiva}
                  onChange={() =>
                    onChange({ target: { name: 'esCargaMasiva', value: !esCargaMasiva } })
                  }
                />
              }
              label='Carga masiva'
              labelPlacement='start'
            />
          </FormGroup>
        </FormControl>
      </Grid>
    </Grid>
  )
}

SelectorDeCarga.propTypes = {
  esCargaMasiva: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}
export default SelectorDeCarga
